(function($){
  $.fn.modalDialog = function(options){
    // eslint-disable-next-line no-unused-vars
    var settings = $.extend({ /*default Settings*/ }, options),
        $body = $('body'),
        $doc = $(document),
        open = 'modal-open',
        active = 'active';

    this.each(function(){
      var $this = $(this),
          modal = $this.attr('href'),
          $modal = $(modal),
          eventOpening = $.Event('modal.opening'),
          eventOpened = $.Event('modal.opened'),
          eventClosing = $.Event('modal.closing'),
          eventClosed = $.Event('modal.closed'),
          $modalStage = $modal.find('.zn-modal-stage'),
          $close = $modal.find('.zn-close-modal'),
          closeThis = function(e){
            e.trigger('modal.closing');
            $modal.removeClass(active);
            $modal.fadeOut(200, function(){
              e.trigger('modal.closed');
            });
            
            $body.removeClass(open)
            $doc.off('click.modal').off('keydown.modal').off('focusin.modal');

            $this.focus();
          };

      $modalStage.attr('role', 'dialog').attr('aria-modal', 'true');

      $this.on('click', function(clickEvent){
        clickEvent.preventDefault();
        if(!$body.hasClass(open)){
          $this.trigger('modal.opening');
          $body.addClass(open);
          $modal.fadeIn(200, function(){
            $modal.addClass(active);
            $this.trigger('modal.opened');
            $modalStage.attr('tabindex', '0').focus();

            $doc.on('focusin.modal', function(e){
              //var focusedItem = $(document.activeElement);
              if ($body.hasClass(open) && !$.contains($modal.get(0), e.target)){
                $modalStage.focus();
              }
            }).on('click.modal', function(e){
              e.stopPropagation();
              if(!$modal.find(e.target).length){
                closeThis($this);
              }
            }).on('keydown.modal', function(e){
              e.stopPropagation();
              var keyCode = e.which;

              if(keyCode === 27){
                closeThis($this);
              }
            });
          });
        }
      });

      if ($close.length){
        $close.addAccess();
        $close.on('click', function(){
          closeThis($this);
        });
      }
    });

    return this;
  };

  $(function(){
    var $modalLink = $('.zn-modal-link'),
        $modalDialog = $('.zn-modal');

    if ($modalLink.length && $modalDialog.length){
      $modalLink.modalDialog();

      // $modalLink.modalDialog().on('modal.open', function(){
      //   console.log('opened');
      // }).on('modal.close', function(){
      //   console.log('closed');
      // });
    }
  });
})($JQ);